function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h32v32H0z" /><circle cx="16" cy="16" r="15.5" fill="#FFF" stroke="#A8ACBB" /><path d="M10 16.667a.667.667 0 0 1 0-1.334h12a.667.667 0 0 1 0 1.334H10zm0-4a.667.667 0 0 1 0-1.334h12a.667.667 0 0 1 0 1.334H10zm0 8a.667.667 0 0 1 0-1.334h12a.667.667 0 0 1 0 1.334H10z" fill="#A8ACBB" fillRule="nonzero" /></g></svg>;
});